import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MemberService } from "src/app/services/member.service";

import { MemberSearchPayload, MemberSearchResult } from "src/app/models/member-lookup";
import { ContentHeaderKey } from "src/app/constants/content-header";

@Component({
    selector: 'mwp-member-search',
    templateUrl: './search.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberSearchComponent implements OnInit {
    public members: MemberSearchResult[];
    public member: MemberSearchResult;
    public displayConfirmMember: boolean;
    public apiUrl = ContentHeaderKey.CounselorMemberLookup;

    constructor(
        private memberService: MemberService
    ) {
    }

    ngOnInit() {
    }

    public search(payload: MemberSearchPayload): void {
        this.memberService.searchMembers(payload).subscribe((response: MemberSearchResult[]) => {
            this.members = response;
        });
    }

    public selectedMember(selectedMember: MemberSearchResult): void {
        this.displayConfirmMember = true;
        this.member = selectedMember;
    }

    public back(): void {
        this.displayConfirmMember = false;
    }
}